/* src/app/merchants/merchant-visahistory/merchant-visahistory.component.css */
.panel {
  border-radius: 0px;
}
.panel-nc {
  border-radius: 0px;
  border: 1px solid #414141;
  background: none;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
  -webkit-box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  -moz-box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  box-shadow: 2px 2px 2px 0px rgba(65, 65, 65, 0.5);
  margin-top: 20px;
}
.fa {
  font-size: 9pt;
}
/*# sourceMappingURL=merchant-visahistory.component.css.map */
